type NoJobDataErrorDetails = {
    jobId: string
}

export class NoJobDataError extends Error {
    details?: NoJobDataErrorDetails

    constructor(message: string, details: NoJobDataErrorDetails) {
        super(message)
        this.details = details
        Object.setPrototypeOf(this, new.target.prototype) // Required for proper inheritance
    }
}
